var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataScience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9846 8.50001H8.20711L2.70769 13.9994C4.11804 15.2445 5.97079 16 8 16C12.2504 16 15.7265 12.6854 15.9846 8.50001Z",
    fill: "#FEA101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00058 13.2923C0.755509 11.882 0 10.0292 0 8.00001C0 3.74966 3.31464 0.273479 7.5 0.0153809V7.7929L2.00058 13.2923Z",
    fill: "#FEA101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0.0153809V7.50001H15.9846C15.7367 3.48 12.52 0.263282 8.5 0.0153809Z",
    fill: "#FEA101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataScience);
export default __webpack_public_path__ + "static/media/DataScience.576e5d8e86fbefc93a9e15cc6d28f0b1.svg";
export { ForwardRef as ReactComponent };